module.exports = __webpack_public_path__ + "static/img/semi-heavy-horse-white.50da635.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/semi-heavy-horse-white.svg
// module id = wR6a
// module chunks = 74